import { styled } from '@mui/material';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-around',
  border: `1px solid ${theme.palette.secondary.main}`,
  padding: '0.5rem 1.25rem',
  borderRadius: '1.4rem',
  height: '2.5rem',
  gap: '0.5rem',
}));
